export const CREATE_COLOR = 'CREATE_COLOR';
export const CREATE_COLOR_ERROR = 'CREATE_COLOR_ERROR';
export const CREATE_COLOR_REQUEST = 'CREATE_COLOR_REQUEST';
export const CREATE_COLOR_SUCCESS = 'CREATE_COLOR_SUCCESS';

export const DELETE_COLOR = 'DELETE_COLOR';
export const DELETE_COLOR_ERROR = 'DELETE_COLOR_ERROR';
export const DELETE_COLOR_REQUEST = 'DELETE_COLOR_REQUEST';
export const DELETE_COLOR_SUCCESS = 'DELETE_COLOR_SUCCESS';

export const EDIT_COLOR = 'EDIT_COLOR';
export const EDIT_COLOR_ERROR = 'EDIT_COLOR_ERROR';
export const EDIT_COLOR_REQUEST = 'EDIT_COLOR_REQUEST';
export const EDIT_COLOR_SUCCESS = 'EDIT_COLOR_SUCCESS';

export const GET_COLOR = 'GET_COLOR';
export const GET_COLOR_ERROR = 'GET_COLOR_ERROR';
export const GET_COLOR_REQUEST = 'GET_COLOR_REQUEST';
export const GET_COLOR_SUCCESS = 'GET_COLOR_SUCCESS';

export const GET_COLORS = 'GET_COLORS';
export const GET_COLORS_ERROR = 'GET_COLORS_ERROR';
export const GET_COLORS_REQUEST = 'GET_COLORS_REQUEST';
export const GET_COLORS_SUCCESS = 'GET_COLORS_SUCCESS';

export const SET_COLOR = 'SET_COLOR';
export const SET_COLORS = 'SET_COLORS';
